export default __webpack_public_path__ + "static/media/Dual-Ju-ITLA.85bf09c7.png";